export default __webpack_public_path__ + "static/chair_b-c31af1d3dd293b4f7311d67a377688a4.jpg";